import { CornerDownRight } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgDownAndRightArrow = mkIcon(CornerDownRight);